<template>
  <div class="go-home-icas" :class="{'gray':isLogin,'white':!isLogin}" @click="toHomepage">
    <img v-if="isIscoTheme" src="@/assets/login_images/home_black.svg">
    <img v-else-if="isLogin" src="@/assets/login_images/home.png">
    <img v-else src="@/assets/common/home.png">
    <span v-if="isOS && uiConfig.sfTheme">
      {{ $t('__origin__.standard.home') }}
    </span>
    <span v-else>{{ homeTitle }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { jumpToOwt } from '@/utils/index.js'
import { isOS, ISCO, ISCO_OS, ISCOUS, isMy } from '@/utils/constant'

export default {
  name: 'Homepage',
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOS: isOS(),
      ISCO: ISCO
    }
  },
  computed: {
    ...mapGetters(['language', 'userInfo', 'uiConfig', 'system_source']),
    isIscoTheme() {
      return [ISCO, ISCO_OS, ISCOUS].includes(this.system_source)
    },
    homeTitle() {
      if (!isOS()) {
        return this.$t('standard.home')
      }
      if (isMy()) {
        return this.$t('standard.home')
      } else {
        return this.$t('standard.home').replace('ABX', 'KEX')
      }
    }
  },
  methods: {
    toHomepage() {
      jumpToOwt(this.userInfo.token, this.uiConfig.sfTheme)
      this.$track({ sceneType: 'Login', eventType: 'ClicClick_On_International_Official_Websitek_HomeTab_Execute', message: '' })
      // const obj = getEnvObj()
      // // const env = process.env.VUE_APP_ENV
      // // 日语生产环境 - 未登录跳转url：https://www.sf-international.com/jp/ja/index.html，已登录跳转url：未登录跳转url?token=xxx
      // // 日语测试环境 - 未登录跳转url：http://www.sit.sf-international.com:9888/jp/ja/index.html, 已登录跳转url：未登录跳转url?token=xxx
      // // 非日语生产环境 - 未登录跳转url：https://ibu-owt-site.sf-express.com/cn/sc, 已登录跳转url：https://ibu-owt-site.sf-express.com/core-service/web/newUser/link?token=xxx&url=未登录跳转url
      // // 非日语测试环境 - 未登录跳转url：https://ibu-owt.sit.sf-express.com/cn/sc, 已登录跳转url：https://ibu-owt.sit.sf-express.com/core-service/web/newUser/link?token=xxx&url=未登录跳转url
      // let toUrl = ''
      // if (this.language === 'ja-JP') { // 日语环境
      //   // if (env === 'development' || env === 'production' || env === 'gcp-sit') { // 本地环境，顺丰云测试环境，gcp测试环境
      //   //   toUrl = 'http://www.sit.sf-international.com:9888/jp/ja/index.html'
      //   // } else { // 生产环境
      //   //   toUrl = 'https://www.sf-international.com/jp/ja/index.html'
      //   // }
      //   toUrl = obj.OWT_URL_JP
      //   if (this.userInfo.token) { // 有token
      //     toUrl = toUrl + '?token=' + this.userInfo.token
      //   }
      // } else { // 非日语环境
      //   let loginedUrl = '' // 已登录带token的路径
      //   // if (env === 'development' || env === 'production' || env === 'gcp-sit') { // 本地环境，顺丰云测试环境，gcp测试环境
      //   // toUrl = 'https://ibu-owt.sit.sf-express.com/cn/sc'
      //   // loginedUrl = 'https://ibu-owt.sit.sf-express.com/core-service/web/newUser/link'
      //   // if (this.userInfo.token) { // 有token
      //   toUrl = obj.OWT_URL_CN
      //   loginedUrl = obj.OWT_URL_CN_LOGINING
      //   const token = this.userInfo.token ? ('?token=' + this.userInfo.token + '&url=') : '?url='
      //   toUrl = loginedUrl + token + toUrl
      //   // }
      //   // } else { // 生产环境
      //   //   // toUrl = 'https://ibu-owt-site.sf-express.com/cn/sc'
      //   //   // loginedUrl = 'https://ibu-owt-site.sf-express.com/core-service/web/newUser/link'
      //   //   toUrl = 'https://www.sf-international.com'
      //   //   if (this.userInfo.token) { // 有token
      //   //     toUrl = toUrl + '?token=' + this.userInfo.token
      //   //   }
      //   // }
      // }
      // window.open(toUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.go-home-icas{
  cursor: pointer;
  >img{
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
  }
  span{
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
  }
}
.gray{
  color: $color02;
}
.white{
  color: $color01;
}
</style>
